import React, { useContext } from "react";
import {GlobalAppContext} from "../Store";


const useStore = () => {
    return useContext(GlobalAppContext)
}

export default useStore